export const scrollbarStyles =
  "scrollbar-thin scrollbar-thumb-zinc-300 scrollbar-track-transparent";
